<a [routerLink]="['/aqi/detail/', aqiData?.deviceeui]">
    <nz-card class="glass-card cursor-pointer">
        <div class="flex items-center gap-x-2 mb-2">
            <span class="text-xs font-semibold text-gray-800 truncate">
                {{ aqiData?.name || 'Unnamed Location' }}
            </span>
        </div>
        <div class="flex justify-between items-center mb-1">
            <div class="flex items-center gap-x-3">
                <div class="flex flex-col justify-center items-start">
                    <div class="flex items-center gap-x-1 mt-0.5">
                        <span class="text-2xl tracking-wide text-gray-700 font-semibold">AQI</span>
                        <span class="inline-flex items-center justify-center text-2xl font-extrabold leading-5"
                            [style.color]="getAqiRange(aqiData?.['aqi'] || 0).color">
                            {{ aqiData?.['aqi'] != null ? aqiData?.['aqi'] : '--' }}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <i nz-icon nzType="barcode" nzTheme="outline" class="text-lg cursor-pointer"></i>
                {{ aqiData?.deviceeui }}
            </div>
        </div>
        <div class="flex justify-between items-center">
            <div class="flex items-baseline gap-x-1">
                <span class="text-gray-700">
                    <span class="font-semibold">PM2.5 :</span>
                    {{ aqiData?.['pm2_5'] }} µg/m³
                </span>
            </div>
            <div class="flex items-baseline gap-x-1">
                <span class="text-gray-700">
                    <span class="font-semibold">PM1.0 :</span>
                    {{ aqiData?.['pm1'] }} µg/m³
                </span>
            </div>
            <div class="flex items-baseline gap-x-1">
                <span class="text-gray-700">
                    <span class="font-semibold">PM10 :</span>
                    {{ aqiData?.['pm10'] }} µg/m³
                </span>
            </div>
        </div>
        <app-aqi-status-bar [currentAqi]="currentAqi"></app-aqi-status-bar>
    </nz-card>
</a>